import {DbNote} from '../services/master-records.service';

export enum ITEM_TYPE {
  CMP_TYPE = 'CMP_TYPE'
}

export class CmpType {
  constructor(public aitemId: number,
              public cmpTypeId: number,
              public cmpTypeName: string,
              public itemType: ITEM_TYPE.CMP_TYPE
  ) {
    this.aitemId = aitemId;
    this.cmpTypeId = cmpTypeId;
    this.cmpTypeName = cmpTypeName;
    this.itemType = itemType;
  }
}

export class Attribute {
  constructor(
    public attributeDefId: number,
    public attributeId: number,
    public attributeName: string,
    public attributeValue: string
  ) {
    this.attributeDefId = attributeDefId;
    this.attributeId = attributeId;
    this.attributeName = attributeName;
    this.attributeValue = attributeValue;
  }
}

export class AttributeGroup {
  constructor(
    public attrGrId: number,
    public attrGrName: string,
    public attributes: Attribute[]
  ) {
    this.attrGrId = attrGrId;
    this.attrGrName = attrGrName;
    this.attributes = attributes;
  }
}

export class OsComponent {
  constructor(
    public cmpArchitecture: string,
    public cmpCategory: OS_CMP_CATEGORY = null,
    public cmpDesc: string,
    public cmpItemId: number,
    public cmpName: string,
    public cmpVersion: string,
    public cmpTypes: CmpType[],
    public attributeGroups: AttributeGroup[],
    public note: DbNote,
    public cmpAttrVendor: Attribute = null,
    public cmpAttrFamily: Attribute = null,
    public supplierName: string = null,
    public productInstComponentType: CmpType = null
  ) {
  }

  static createOsComponent(osComponent: OsComponent): OsComponent {
    const newOsComponent: OsComponent = new OsComponent(
      osComponent.cmpArchitecture,
      osComponent.cmpCategory,
      osComponent.cmpDesc,
      osComponent.cmpItemId,
      osComponent.cmpName,
      osComponent.cmpVersion,
      osComponent.cmpTypes,
      osComponent.attributeGroups,
      osComponent.note,
      null,
      null,
      osComponent.supplierName,
      osComponent.productInstComponentType
    );

    osComponent.attributeGroups.forEach((attrGroup: AttributeGroup): void => {
      if (attrGroup.attrGrName === ATTRIBUTE_GROUP_NAME.GENERAL) {
        attrGroup.attributes.forEach((attribute: Attribute): void => {
          switch (attribute.attributeName) {
            case ATTRIBUTE_NAME.VENDOR:
              newOsComponent.cmpAttrVendor = attribute;
              break;
            case ATTRIBUTE_NAME.FAMILY:
              newOsComponent.cmpAttrFamily = attribute;
              break;
          }
        });
      }
    });

    return newOsComponent;
  }
}

export enum ATTRIBUTE_GROUP_NAME {
  GENERAL = 'GENERAL',
  NOTES = 'NOTES',
}

export enum ATTRIBUTE_NAME {
  VENDOR = 'Vendor',
  FAMILY = 'Family',
  NOTES_CONTENT = 'Notes Content'
}

export enum ATTRIBUTE_DEF_ID {
  VENDOR = 1,
  FAMILY = 2,
  NOTES = 5,
  SERVICE_PACK = 8,
  AVAILABILITY_DATE = 9
}

export enum OS_CMP_CATEGORY {
  ALL = 'ALL',
  TYPES = 'TYPES',
  DBMS = 'DBMS',
  MT = 'MT',
  TPC_PREREQ = 'TPC_PREREQ',
  TPC = 'TPC',
  UI_LANG = 'UI_LANG',
  DOCS_LANG = 'DOCS_LANG',
  LANGUAGES = 'LANGUAGES' // use only for master records table
}

export enum OS_CMP_CATEGORY_TITLE {
  ALL = 'Other Technologies',
  TYPES = 'Types of Technologies',
  DBMS = 'Databases',
  MT = 'Managed Technologies',
  TPC_PREREQ = 'Third Party Prerequisites',
  TPC = 'Third Party Product Compatibilities',
  UI_LANG = 'UI Languages',
  DOCS_LANG = 'Docs Languages',
  LANGUAGES = 'Languages' // use only for master records table
}

